import React from "react";
import { Box, Button, Chip, Typography } from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";

// Brand blue used across the panel (breadcrumb, table heads).
export const BRAND_BLUE = "#0555c8";

// Rounded, lightly-shadowed table container.
export const pricingTableContainerSx = {
  borderRadius: 2,
  border: "1px solid #e6e9f0",
  boxShadow: "0 1px 3px rgba(16,24,40,0.06)",
  overflow: "hidden",
};

// Brand-blue header row with white, slightly-tracked labels.
export const pricingTableHeadSx = {
  backgroundColor: BRAND_BLUE,
  "& .MuiTableCell-head": {
    color: "#fff",
    fontWeight: 600,
    fontSize: 12.5,
    letterSpacing: 0.3,
    whiteSpace: "nowrap",
  },
};

// Zebra striping + hover for body rows.
export const pricingBodyRowSx = {
  "&:nth-of-type(odd)": { backgroundColor: "#fafbfe" },
  "&:hover": { backgroundColor: "#eef3ff" },
  "& .MuiTableCell-body": { fontSize: 13 },
};

// Green/grey active-state chip.
export const StatusChip: React.FC<{ active: boolean; labels?: [string, string] }> = ({
  active,
  labels = ["Active", "Inactive"],
}) => (
  <Chip
    size="small"
    label={active ? labels[0] : labels[1]}
    sx={{
      fontWeight: 600,
      fontSize: 11,
      height: 22,
      color: active ? "#0a7d3e" : "#667085",
      backgroundColor: active ? "#e7f7ee" : "#f2f4f7",
      border: `1px solid ${active ? "#abe2c4" : "#e0e3ea"}`,
    }}
  />
);

// Page header: title + subtitle on the left, optional primary action on the right.
export const PricingPageHeader: React.FC<{
  title: string;
  subtitle?: string;
  actionLabel?: string;
  onAction?: () => void;
}> = ({ title, subtitle, actionLabel, onAction }) => (
  <Box
    sx={{
      m: 2,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: 2,
    }}
  >
    <Box>
      <Typography sx={{ fontWeight: 700, fontSize: 20, color: "#101828" }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography sx={{ fontSize: 13, color: "#667085", mt: 0.5 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
    {actionLabel && onAction && (
      <Button
        variant="contained"
        startIcon={<AddRoundedIcon />}
        onClick={onAction}
        sx={{
          backgroundColor: BRAND_BLUE,
          textTransform: "none",
          fontWeight: 600,
          borderRadius: 2,
          "&:hover": { backgroundColor: "#0445a3" },
        }}
      >
        {actionLabel}
      </Button>
    )}
  </Box>
);
